import React, { lazy } from "react";

const LazyEditContact = lazy(() => import("./EditContact"));

const EditContact = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditContact {...props} />;

export default EditContact;
